import { X } from 'lucide-react'
import { Dialog as RadixDialog } from 'radix-ui'

import { useBrandStore } from '@/brand'
import { IconButton } from '@/design'
import { BrandLogo } from './brand-logo'
import { NavList } from './nav-list'

/** Off-canvas navigation under 768 px. A Radix Dialog gives focus trapping and Escape for free. */
export function MobileNav({
  open,
  onOpenChange,
}: {
  readonly open: boolean
  readonly onOpenChange: (open: boolean) => void
}) {
  const brand = useBrandStore((state) => state.brand)
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-50 bg-ink/50 md:hidden" />
        <RadixDialog.Content className="fixed inset-y-0 left-0 z-50 flex w-[min(300px,85vw)] flex-col bg-[linear-gradient(180deg,var(--brand-primary-deep),color-mix(in_srgb,var(--brand-primary-deep)_80%,black))] px-4 py-5 text-[#E7ECF6] outline-none md:hidden">
          <RadixDialog.Title className="sr-only">Navigation</RadixDialog.Title>
          <RadixDialog.Description className="sr-only">
            Main navigation for {brand.product_name}
          </RadixDialog.Description>
          <div className="mb-4 flex items-center justify-between border-b border-white/10 pb-4">
            <BrandLogo size="sm" onDark className="min-w-0" />
            <RadixDialog.Close asChild>
              <IconButton
                label="Close navigation"
                variant="ghost"
                size="sm"
                className="text-white hover:bg-white/10"
              >
                <X />
              </IconButton>
            </RadixDialog.Close>
          </div>
          <NavList
            onNavigate={() => {
              onOpenChange(false)
            }}
          />
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}
